var exports = {
  "i": "AltTextBadge.module__wrapper___R01EYz",
  "x": "AltTextBadge.module__button___R01EYz",
};

module.exports = exports;
